// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/Working/Hydrop/xmanager/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from 'D:/Working/Hydrop/xmanager/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import SettingOutlined from 'D:/Working/Hydrop/xmanager/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { SmileOutlined, CrownOutlined, SettingOutlined };
